// Standardized color palette for use in inline styles
export const colors = {
  brandPrimary: '#225f78',
  brandSecondary: '#7529b8',
  brandAccent: '#667eea',
  brandAccentDark: '#764ba2',
  success: '#4caf50',
  white: '#ffffff',
  black: '#000000',
  grayLight: '#f3f3f3',
  gray: '#5e5e5e',
  grayDark: '#353e5c',
};

export const gradients = {
  primary: 'linear-gradient(90deg, #225f78 0%, #7529b8 100%)',
  secondary: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  hero: 'linear-gradient(135deg, #667eea 0%, #8e2de2 30%, #880e4f 70%, #4a148c 100%)',
};
